<template>
  <section
    class="bg-gray-800 bg-no-repeat bg-cover bg-center select-none px-5 md:px-8 rounded-md shadow-md mt-10 mx-2"
    :style="backgroundImage(course?.file?.url || emptyImg)"
  >
    <div
      class="container mx-auto grid grid-cols-12 gap-5 py-12 h-full items-center"
    >
      <div
        class="col-span-12 md:col-span-6 text-center md:text-start text-white"
      >
        <h4>{{ course?.name }}</h4>
        <div
          class="flex justify-center md:justify-start gap-x-8 flex-col md:flex-row"
        >
          <p v-if="course?.duration">
            {{
              $t("labels.generic", {
                pt: "Duração estimada do curso: ",
                en: "Estimated course duration: ",
              })
            }}
            {{ generics.getDurationTime(course?.duration) }}
          </p>
        </div>
        <div
          v-if="course?.categories?.length !== 0"
          class="flex justify-center md:justify-start flex-wrap gap-5 mt-5"
        >
          <p
            class="px-3 py-1 bg-gray-300 text-black text-sm font-medium rounded-full"
            v-for="(item, i) in course?.categories"
            :key="i"
          >
            {{ item?.name }}
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { CoursesGenerics } from "@/utils/courses.util";
import { GenericsUtils } from "@/utils/generics.util";
import { getUserFromStorage } from "@/utils/user-store.util";
import { defineComponent } from "vue";

export default defineComponent({
  name: "heroChapters",
  computed: {
    courseGenerics(): CoursesGenerics {
      return new CoursesGenerics();
    },
    generics(): GenericsUtils {
      return new GenericsUtils();
    },
    user(): any {
      return getUserFromStorage();
    },
  },
  data() {
    return {
      emptyImg:
        "https://video-thumb.s3.sa-east-1.amazonaws.com/65197bdbplaceholder.png" as string,
    };
  },
  props: {
    course: Object,
  },
  methods: {
    backgroundImage(image: string): any {
      return {
        "background-image": `linear-gradient(
              to bottom right,
              rgba(0, 0, 0, 0.5),
              #353535 90%
            ),url(${image})`,
      };
    },
  },
});
</script>
